import { z } from 'zod';
import type { Owner } from '../types/state';

export const personalInfoSchema = z.object({
  gender: z.string().nonempty(),
  birthdate: z.string(),
  birthCity: z.string().nonempty(),
  birthCountry: z.string().nonempty(),
  birthZipcode: z.string().nonempty(),
  nationality: z.string().nonempty(),
});

export type PersonalInfoSchema = z.infer<typeof personalInfoSchema>;

export const addressSchema = z.object({
  addressLine1: z.string().nonempty(),
  addressLine2: z.string().optional(),
  addressCity: z.string().nonempty(),
  addressCountry: z.string().nonempty(),
  addressZipcode: z.string().nonempty(),
});

export type AddressSchema = z.infer<typeof addressSchema>;

export const personalInfoWithAddressSchema = z.object({
  ...personalInfoSchema.shape,
  ...addressSchema.shape,
});

export type PersonalInfoWithAddressSchema = z.infer<typeof personalInfoWithAddressSchema>;

export function hasPersonalInfo(owner: Owner): boolean {
  return personalInfoSchema.safeParse({
    gender: owner.gender,
    birthdate: owner.birthdate,
    birthCity: owner.birthCity,
    birthCountry: owner.birthCountry,
    birthZipcode: owner.birthZipcode,
    nationality: owner.nationality,
  }).success;
}
